export enum FilterType {
    Multiselect,
    DateRangePicker,
}
